module.exports = __webpack_public_path__ + "img/bg-type02-pc02.045fb477.png";